// extracted by mini-css-extract-plugin
module.exports = {"readerTranslationsPopupHeight":"7.1"};